'use es6';

import * as http from '../request/http';
import toJS from '../lib/toJS';
const getURL = endpoint => `multi-currency/v2/currencies/${endpoint}`;
export const getCurrencyInformation = () => http.get(getURL('information')).then(toJS);